/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InstallmentPaymentSumFinancierReport = {
    financierPaymentChannelId?: string;
    accountName?: string;
    accountId?: string;
    paymentChannelType?: InstallmentPaymentSumFinancierReport.paymentChannelType;
    bankCode?: InstallmentPaymentSumFinancierReport.bankCode;
    sumTotal?: number;
    rowCount?: number;
    downPaymentSum?: number;
    downPaymentCount?: number;
    termPaymentSum?: number;
    termPaymentCount?: number;
    finePaymentSum?: number;
    finePaymentCount?: number;
};
export namespace InstallmentPaymentSumFinancierReport {
    export enum paymentChannelType {
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        PROMPT_PAY_QR = 'PROMPT_PAY_QR',
        BANK_ACCOUNT = 'BANK_ACCOUNT',
        AUTOMATIC_QR = 'AUTOMATIC_QR',
        TRUE_WALLET = 'TRUE_WALLET',
        CHILLPAY_QR = 'CHILLPAY_QR',
    }
    export enum bankCode {
        BBL = 'BBL',
        BAY = 'BAY',
        SCB = 'SCB',
        KBANK = 'KBANK',
        KTB = 'KTB',
        TTB = 'TTB',
    }
}

